import { ViewFactory } from 'wdc-cube-react'

import { GroupProfileScope } from '../gp_scopes'

import { HeaderScope } from '../gp_scopes'
import GroupProfileView from './gp_view'
import HeaderView from './gp-header'

export function registerViews(rv = ViewFactory.register) {
    rv(GroupProfileScope, GroupProfileView)
    rv(HeaderScope, HeaderView)
}
